import {
    ChangeDetectionStrategy,
    Component,
    Input,
    OnChanges,
    SimpleChanges,
} from "@angular/core";

@Component({
  standalone: false,
    selector: "app-option-row",
    templateUrl: "./option-row.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OptionRowComponent implements OnChanges {
    row: Record<string, unknown> = {};

    @Input() set option(value: object) {
        this.row = (value ?? {}) as Record<string, unknown>;
    }
    @Input() fields: string[] = [];
    @Input() isHeader = false;
    @Input() labelMap: Record<string, string> = {};
    @Input() badgeFields: string[] = [];

    badgeFieldSet = new Set<string>();

    ngOnChanges(changes: SimpleChanges): void {
        if (changes["badgeFields"]) {
            this.badgeFieldSet = new Set(this.badgeFields);
        }
    }

    getLabel(field: string): string {
        return this.labelMap[field] ?? field;
    }

    getBadgeClass(value: unknown): string {
        return value ? "linked" : "not-linked";
    }
}
